import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new Subject<ToastMessage>();
  toastState$ = this.toastSubject.asObservable();

  show(message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info', duration?: number) {
    const defaultDuration = type === 'error' ? 5000 : type === 'warning' ? 4000 : 3000;
    this.toastSubject.next({ message, type, duration: duration ?? defaultDuration });
  }
}
